__turbopack_context__.v({
  "lds-dual-ring": "vIla9q_lds-dual-ring",
  "textsizespinner": "vIla9q_textsizespinner",
});
